import { render, staticRenderFns } from "./DocumentCompletion.vue?vue&type=template&id=af3d9c1a&scoped=true&"
import script from "./DocumentCompletion.vue?vue&type=script&lang=js&"
export * from "./DocumentCompletion.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCompletion.vue?vue&type=style&index=0&id=af3d9c1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3d9c1a",
  null
  
)

export default component.exports